<script lang="ts" setup>
import { onMounted } from "vue";
import { getDemoLogin, severityCode } from "@/services/api/demo.api";
import { useAuthStore } from "@/stores/auth";
import { useUserStore } from "@/stores/user";
import router from "@/router/index";

const props = defineProps({
  type: String,
});

onMounted(async () => {
  const authStore = useAuthStore();
  const userStore = useUserStore();
  try {
    const demoUser = await getDemoLogin(props.type);
    console.log("DemoLogin, authorized: ", demoUser, props.type);

    if (demoUser && demoUser.severity <= severityCode.warning) {
      authStore.setDemoUserAccessToken({ token: demoUser.data });
      if (demoUser.data) {
        const authorized = await authStore.isAllowedForApplication();
        console.log("DemoLogin, authorized: ", authorized);
        if (authorized) {
          await userStore.setUserAccessData();
            router.push({ name: "Dashboard", params: { partyReference: userStore.currentPartyReference }});
        } else {
          console.log("DemoLogin, user unauthorized for application");
          router.push({ name: "Unauthorized" });
        }
      } else {
        console.log("DemoLogin unknown, user unauthorized for application");
        router.push({ name: "Unauthorized" });
      }
    } else {
      console.log("DemoLogin, error: ", demoUser.code, demoUser.message);
      router.push({ name: "Unauthorized" });
    }
  } catch (error) {
    console.log("DemoLogin, error: ", error);
    router.push({ name: "Unauthorized" });
  }
});
</script>

<template>
  <v-container class="h-100 callback">
    <v-row class="h-100" align="center" justify="center">
      <v-col cols="auto"> Aanmelding voltooien... </v-col>
    </v-row>
  </v-container>
</template>
